const formatFiledDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value).slice(0, 10);
  return date.toLocaleDateString();
};

export default function DuplicateNotice({ duplicateOf, onView, testId }) {
  if (!duplicateOf) return null;

  const name = duplicateOf.filename || duplicateOf.label || "this document";
  const filed = formatFiledDate(duplicateOf.filed_at);
  const canView = duplicateOf.archive_source && duplicateOf.archive_item_id;

  return (
    <div
      data-testid={testId}
      className="rounded-lg border border-[hsl(35_70%_75%)] bg-[hsl(35_70%_94%)] px-4 py-3 flex items-start gap-2.5"
    >
      <span className="text-[10px] font-bold tracking-wider uppercase rounded-sm px-2 py-0.5 bg-[hsl(35_70%_46%)] text-white shrink-0 mt-0.5">
        Duplicate
      </span>
      <div className="flex-1 min-w-0">
        <p className="text-[13px] font-semibold text-[hsl(28_55%_28%)] break-words">
          Duplicate of {name}{filed ? `, filed ${filed}` : ""}.
        </p>
        <p className="text-[11px] text-[hsl(28_45%_44%)] mt-1">
          Discard this upload (recommended), or click &ldquo;File document&rdquo; to file it anyway (for example, a re-issued or corrected statement).
        </p>
        {canView && (
          <button
            type="button"
            data-testid="duplicate-view-link"
            onClick={() => onView?.(duplicateOf)}
            className="mt-2 text-[12px] font-semibold text-[hsl(var(--ploy-rust))] hover:underline"
          >
            View matching document
          </button>
        )}
      </div>
    </div>
  );
}
